import React from "react";
import Chart from "react-apexcharts";
import { useMonthlyRevenue } from "../../../Payments/hooks/useMonthlyRevenue";

const PaymentsChart: React.FC = () => {
  const monthlyRevenue = useMonthlyRevenue();

  const options: ApexCharts.ApexOptions = {
    chart: {
      height: 350,
      type: "area",
      toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ],
    },
    tooltip: {
      y: {
        formatter: (val) => `MWK ${val.toLocaleString()}`,
      },
    },
  };

  const series = [
    {
      name: "Revenue",
      data: monthlyRevenue,
    },
  ];

  return (
    <div className="bg-card p-4 rounded-lg shadow">
      <div className="flex items-center justify-between">
        <h2 className="text-md text-white font-semibold mb-4">Revenue Trend</h2>
        <h2 className="text-md text-white font-semibold mb-4">
          {new Date().getFullYear()}
        </h2>
      </div>
      <p className="text-sm text-white mb-2">
        Total Revenue: MWK {monthlyRevenue.reduce((total, value) => total + value, 0)}
      </p>
      <Chart options={options} series={series} type="area" height={350} />
    </div>
  );
};

export default PaymentsChart;
